export default "__VITE_ASSET__oykCnYne__"